/**
 * Valida data no formato dd/mm/yyyy
 * @param date - Data a ser validada no formato dd/mm/yyyy
 * @returns true se a data for válida no formato, false caso contrário
 * @example
 * isValidDate('25/12/2023') // true
 * isValidDate('31/02/2023') // true (formato válido, mas data inexistente)
 * isValidDate('25/12/23') // false (ano com 2 dígitos)
 * isValidDate('2023-12-25') // false (formato americano)
 * isValidDate('25-12-2023') // false (separador hífen)
 */
export const isValidDate = (date: string): boolean => {
  const dateRegex = /^(0[1-9]|[12][0-9]|3[01])\/(0[1-9]|1[0-2])\/\d{4}$/;
  return dateRegex.test(date);
};
